<template>
  <PrmSkeleton
    v-if="appStore.isNavigating"
    width="40px"
  />
  <template v-else>
    <router-link
      v-if="route.meta.appId !== undefined"
      v-slot="{
        href, navigate,
      }"
      :to="{
        name: appListMap[route.meta.appId].route as any,
      }"
      custom
    >
      <a
        :href="href"
        :title="i18n.global.t(`api.AppId.${route.meta.appId}`)"
        @click="navigate"
      >
        <div class="typo-h3">
          {{ title }}
        </div>
      </a>
    </router-link>
    <div
      v-else
      class="typo-h3"
    >
      {{ title }}
    </div>
  </template>
</template>

<script setup lang="ts">
import PrmSkeleton from '@NitrexGroup/primevue/skeleton';
import {
  i18n,
} from '@i18n';
import {
  computed,
} from 'vue';
import {
  useRoute,
} from 'vue-router';

import {
  useAppStore,
} from '@/store/pinia/app.ts';
import {
  appListMap,
} from '@/types/app-util.ts';

const appStore = useAppStore();
const route = useRoute();

const title = computed(() => {
  return route.meta.titleI18nKey
    ? i18n.global.t(route.meta.titleI18nKey)
    : undefined;
});
</script>
